import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const NotMe = () => (
  <div className="flex items-center justify-center h-screen bg-[#f9f4e8]">
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      className="bg-white p-8 rounded-xl shadow-md w-96 text-center"
    >
      <h2 className="text-xl font-semibold text-gray-800 mb-3">Access Restricted</h2>
      <p className="text-sm text-gray-600 mb-4">
        Please contact your owner, supervisor, or admin for password reset.
      </p>
      <Link
        to="/login"
        className="text-[#7d70b2] hover:underline text-sm font-medium"
      >
        Back to Login
      </Link>
    </motion.div>
  </div>
);

export default NotMe;
